import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";


export default function WebsiteLayout() {
    return (
        <div className="min-h-screen text-black flex flex-col">
            <Navbar />

            {/* Main Content */}
            <main className="flex-1">
                <Outlet />
            </main>

            <Footer />
        </div>
    );
}